import ThumbsUpIcon from "@sprout/icons/thumbs_up";
import ThumbsDownIcon from "@sprout/icons/thumbs_down";
import useTranslation from "@/hooks/use_translation";

export type RecommendationFeedback = "like" | "dislike";

type Props = {
  feedback: RecommendationFeedback | null;
  onChange: (next: RecommendationFeedback | null) => void;
};

const buttonClass = (selected: boolean) =>
  [
    "rounded-full p-1! transition-colors disabled:opacity-50",
    "active:bg-[var(--pale-blue)]!",
    selected ? "bg-[var(--green-100)]!" : "hover:bg-[var(--green-50)]!",
  ].join(" ");

const RecommendationFeedbackButtons = ({ feedback, onChange }: Props) => {
  const { t } = useTranslation("jobSearch");

  const toggle = (value: RecommendationFeedback) => onChange(feedback === value ? null : value);

  return (
    <div className="flex gap-1 items-center flex-none">
      <button
        type="button"
        className={buttonClass(feedback === "like")}
        aria-label={t("recommendationFeedback.like")}
        aria-pressed={feedback === "like"}
        onClick={() => toggle("like")}
      >
        <ThumbsUpIcon size="md" color="dark-green" />
      </button>
      <button
        type="button"
        className={buttonClass(feedback === "dislike")}
        aria-label={t("recommendationFeedback.dislike")}
        aria-pressed={feedback === "dislike"}
        onClick={() => toggle("dislike")}
      >
        <ThumbsDownIcon size="md" color="dark-green" />
      </button>
    </div>
  );
};

export default RecommendationFeedbackButtons;
